import { useEffect } from 'react';
import { DealStore } from '../../../domain/entities/Offer';
import { StoreCoupons } from '../../../infra/api/stores/types/IstoreCouponsQueryDTO';
import { useCouponModal } from '../../modules/StoreTabs/ModalCoupon';
import { getBrowserHref } from '../../services/urls/common';
import { useCurrentUserCache } from '../useCurrentUserCache';

type UseHashCouponModalProps = {
  coupons?: StoreCoupons['coupons'];
  store?: StoreCoupons['store'];
  enabled: boolean;
  isExpiredCoupon: boolean;
};

const useHashCouponModal = ({
  coupons,
  store,
  enabled,
  isExpiredCoupon,
}: UseHashCouponModalProps) => {
  const showCouponModal = useCouponModal();
  const { loggedUser, loading: isCurrentUserLoading = false } =
    useCurrentUserCache();

  const currentUserId = loggedUser?.id || '';

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const currentURL = getBrowserHref();
    const hashCouponMatch = currentURL.match(/#coupon=(.+)$/);
    const hashCouponId = hashCouponMatch ? hashCouponMatch[1] : null;
    if (coupons && coupons.length && hashCouponId) {
      const hashCoupon = coupons.find(
        (coupon) => coupon && coupon.id === hashCouponId
      );

      const shouldShowCouponModal =
        hashCoupon && hashCoupon.couponCode && !isCurrentUserLoading;

      if (shouldShowCouponModal) {
        window.history.replaceState(null, '', currentURL.split('#')[0]);
        showCouponModal({
          isExpiredCoupon,
          deal: {
            ...hashCoupon,
            couponCode: hashCoupon.couponCode,
            store: store as unknown as DealStore,
          },
          currentUserId,
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    coupons,
    enabled,
    store,
    isExpiredCoupon,
    currentUserId,
    isCurrentUserLoading,
  ]);
};

export default useHashCouponModal;
